import { DocumentationFileStructureModel } from 'src/app/core/models/doc-file-structure.model';

export function getFirstDoc(pages: DocumentationFileStructureModel[]): string {
    for (const p of pages) {
        if (p.type === 0) return getFirstDoc(p.children ?? []);
        return p.path!;
    }
    return '';
}
